
<template>
  <footer class="footer text-white">
    <!-- Conteneur principal avec overlay bleu -->
    <div class="footer-overlay">
      <div class="footer-main d-flex flex-column flex-md-row justify-content-between">
        <div class="container-fluid px-5 py-5">
          <div class="row gy-4">
            <!-- Colonne Careers -->
            <div class="col-md-4">
              <h5 class="fw-bold mb-3">Careers</h5>
              <p>
                Actuellement, nous n'avons pas d'opportunités, mais nous sommes impatients de travailler avec des esprits brillants en phase avec les objectifs et la mission de notre entreprise.
              </p>
              <p>
                Veuillez nous envoyer votre profil et vos coordonnées, et nous vous contacterons dès que des opportunités se présenteront. Nous vous remercions.
              </p>
              <h6 class="fw-bold mt-4">Policies</h6>
              <p><a href="#" class="footer-link">Conditions d'utilisation</a></p>
              <p><a href="#" class="footer-link">Politique de confidentialité</a></p>
            </div>

            <!-- Colonne Contact -->
            <div class="col-md-4">
              <h5 class="fw-bold mb-3">Contactez Nous</h5>
              <p><strong>Localisation</strong><br />1 bis Lukusa, Gombe Kinshasa DR Congo</p>
              <p><strong>Adresse Postale</strong><br />Post Office Box CT1254</p>
              <p><strong>Téléphone</strong><br />(+243)839-368-332, 243 808</p>
              <p><strong>Email</strong><br />customercare@one4all.com.gh</p>
            </div>

            <!-- Colonne Formulaire -->
            <div class="col-md-4">
              <div class="contact-form bg-light text-dark p-4 rounded shadow">
                <div class="row g-2">
                  <div class="col-6">
                    <input type="text" class="form-control" placeholder="Prenoms" />
                  </div>
                  <div class="col-6">
                    <input type="text" class="form-control" placeholder="Matière" />
                  </div>
                  <div class="col-6">
                    <input type="email" class="form-control" placeholder="Email" />
                  </div>
                  <div class="col-6">
                    <input type="tel" class="form-control" placeholder="Téléphone" />
                  </div>
                  <div class="col-12">
                    <textarea class="form-control" rows="4" placeholder="Message"></textarea>
                  </div>
                  <div class="col-12 text-center">
                    <button class="btn btn-primary w-100 mt-3">Validez</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer bottom -->
      <div class="footer-bottom py-3 text-center">
        <p class="mb-0 fs-6">&copy; 2025 One4All - Developed and Managed by Prymo.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterView'
}
</script>

<style scoped>
.footer {
  background: url('@/assets/footer-bg.jpg');
  background-size: cover;
  background-position: center;
  position: relative;
  width: 100%;
}

.footer-overlay {
  background-color: rgba(10, 22, 64, 0.95);
  width: 100%;
}

.footer-main {
  padding: 0;
}

.footer-link {
  color: #ffffffcc;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-link:hover {
  color: #42b983;
}

.contact-form input,
.contact-form textarea {
  font-size: 1rem;
}

.contact-form button {
  font-weight: 600;
}

/* Ajustements pour le conteneur fluid */
.container-fluid {
  margin: 0 auto;
}

/* Ajustements responsive */
@media (max-width: 768px) {
  .container-fluid {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  .contact-form {
    margin-top: 20px;
  }
}
</style>